/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_TitleInputs */

const en_mk_team_title = /** @type {(inputs: Mk_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your AI. Run your agent team.`)
};

const id_mk_team_title = /** @type {(inputs: Mk_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih AI-mu. Atur tim agent-mu.`)
};

/**
* | output |
* | --- |
* | "Choose your AI. Run your agent team." |
*
* @param {Mk_Team_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_title = /** @type {((inputs?: Mk_Team_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_title(inputs)
	return en_mk_team_title(inputs)
});